import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Flex, Image, Stack, Table, Text, Tooltip } from "@mantine/core";
import { CloudDownloadOutlined, EditOutlined, OpenInNewOutlined, VisibilityOutlined } from "@mui/icons-material";
import therapproveLogoImage from "../../assets/therapprove-icon-image.png";
import { FileTypeEnum } from "../../graphql/graphql";
import { formatDate } from "../../utils/Date.utils";
import { formatBytes, getFileIconColor, getFileMimeType } from "../../utils/File.utils";
import { ActionsMenu } from "../../shared/ActionsMenu";
import { FileIcon } from "../../shared/Misc/FileIcon";
export const FileRow = ({ file, handlers }) => {
    if (!file)
        return null;
    const { isOriginatingOrganization, originatingOrganization, name, fileName, fileType, mimeType, fileSize, tags, isShared, createdAt } = file;
    const formattedFileType = fileType.replace("_UPLOAD", "");
    // Filtered tags
    const filteredTags = tags?.filter((tag) => tag !== null);
    // Get the color of the icon
    const iconColor = getFileIconColor(fileType);
    return (_jsxs(Table.Tr, { style: { cursor: "pointer" }, onClick: () => {
            const fileMimeType = getFileMimeType(fileName, mimeType);
            handlers.handleOpenFilePreviewModal(file.fileId, fileMimeType, file.tags);
        }, onDoubleClick: (event) => {
            event.stopPropagation();
            event.preventDefault();
        }, children: [_jsx(Table.Td, { style: { paddingLeft: "0.5rem" }, children: _jsx(Tooltip, { label: "This file is shared with Therapprove", position: "right", offset: 10, disabled: !isShared, children: _jsx(Image, { src: therapproveLogoImage, style: {
                            width: "1.3rem",
                            height: "1.3rem",
                            opacity: !!isShared ? 1 : 0
                        } }) }) }), _jsx(Table.Td, { children: _jsxs(Flex, { align: "center", gap: 15, children: [_jsx(FileIcon, { fileType: fileType, style: {
                                color: "var(--mantine-color-white)",
                                backgroundColor: iconColor,
                                padding: "0.3rem",
                                borderRadius: "0.5rem"
                            } }), _jsxs(Stack, { style: { minWidth: 0, flex: 1 }, children: [_jsx(Text, { variant: "body", truncate: "end", children: name }), !isOriginatingOrganization && (_jsx(Text, { variant: "meta", children: originatingOrganization?.name }))] })] }) }), _jsx(Table.Td, { children: formattedFileType }), _jsx(Table.Td, { children: _jsx(Flex, { gap: 6, style: {
                        maxWidth: "35rem",
                        flexWrap: "wrap"
                    }, children: filteredTags?.map((tag) => (_jsx(Badge, { size: "xs", color: "var(--mantine-color-secondary-5)", children: tag }, tag))) }) }), _jsx(Table.Td, { children: _jsx(Text, { variant: "meta-strong", children: formatBytes(fileSize) }) }), _jsx(Table.Td, { visibleFrom: "lg", children: _jsx(Text, { variant: "meta", children: formatDate(createdAt) }) }), _jsx(Table.Td, { children: _jsx(ActionsMenu, { entityId: file.fileId, menuOptions: [
                        {
                            icon: VisibilityOutlined,
                            text: "Preview",
                            onClick: () => {
                                const fileMimeType = getFileMimeType(fileName, mimeType);
                                handlers.handleOpenFilePreviewModal(file.fileId, fileMimeType, file.tags);
                            }
                        },
                        {
                            icon: EditOutlined,
                            text: "Edit",
                            onClick: () => {
                                handlers.handleEditFile(file);
                            }
                        },
                        {
                            icon: CloudDownloadOutlined,
                            text: "Download",
                            onClick: () => {
                                handlers.handleDownloadFile(file.fileId, file.name);
                            }
                        },
                        {
                            icon: OpenInNewOutlined,
                            text: "Open in new tab",
                            isVisible: fileType !== FileTypeEnum.DocumentUpload &&
                                fileType !== FileTypeEnum.ZipUpload &&
                                fileType !== FileTypeEnum.OtherUpload,
                            onClick: () => {
                                handlers.handleNewTab(file.fileId);
                            }
                        }
                    ], allowDelete: true, handleDelete: async () => handlers.handleDelete(file.fileId) }) })] }));
};
